// KAPI · motion leaf — CTA reveal

import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { usePrefersReducedMotion } from "@/lib/animation/prefers-reduced-motion";
import { DUR } from "@/features/landing/motion/tokens";

export function useKapiMotion(scope: React.RefObject<HTMLElement | null>) {
  const reduced = usePrefersReducedMotion();

  useGSAP(
    () => {
      const eyebrow = scope.current?.querySelector<HTMLElement>(".kapi__eyebrow");
      const title = scope.current?.querySelector<HTMLElement>(".kapi__title");
      const sub = scope.current?.querySelector<HTMLElement>(".kapi__sub");
      const contact = scope.current?.querySelector<HTMLElement>(".kapi__contact");

      if (reduced) {
        gsap.set([eyebrow, title, sub, contact], { clearProps: "all" });
        return;
      }

      const tl = gsap.timeline({
        scrollTrigger: { trigger: scope.current, start: "top 75%", toggleActions: "play none none reset" },
      });

      if (eyebrow) tl.fromTo(eyebrow, { autoAlpha: 0, y: 12 }, { autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power2.out" }, 0);
      if (title)    tl.fromTo(title, { autoAlpha: 0, y: 32 }, { autoAlpha: 1, y: 0, duration: DUR.hero, ease: "expo.out" }, 0.1);
      if (sub)     tl.fromTo(sub, { autoAlpha: 0, y: 16 }, { autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power2.out" }, 0.3);
      if (contact) tl.fromTo(contact, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power2.out" }, 0.4);
    },
    { scope, dependencies: [reduced] }
  );
}